import { Link as RouterLink } from "react-router-dom";
import { LinkRoot } from "./Link.styles";
import { Typography } from "@commonlibs";
import { LinkProps } from "./Link.types";

const Link = ({
    to,
    type = "href",
    target = "_self",
    children,
    variant = "body2Regular",
    style,
    className,
    onClick,
    ...rest
}: LinkProps): JSX.Element => {
    // skipcq: JS-0424
    const { LinkComponent, hrefProp } =
        type === "href"
            ? { LinkComponent: "a", hrefProp: { target, onClick, href: to } }
            : {
                LinkComponent: RouterLink,
                hrefProp: { to },
            };

    return (
        <LinkRoot as={LinkComponent} {...(hrefProp as { to: string; target?: string })} style={style} className={className}>
            <Typography variant={variant} singleLine {...rest}>
                {children}
            </Typography>
        </LinkRoot>
    );
};

export default Link;
